import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from 'reducers';
import { useHistory, Link, useLocation } from 'react-router-dom';
import { Globals, Constants } from 'utils';
import { performLogout } from 'utils/logout';
import {
  ArrowLeft,
  ProfileIcon,
  LockIcon,
  LogoutIcon,
  LogoutGray,
  UserSettings,
  MenuIcon,
  Menu,
} from 'assets/icons';
import { Logo, WhiteImage } from 'assets/img';
import { useApacuana } from 'contexts/ApacuanaContext';

interface Props {
  className?: string;
  toggleSidebar?: any;
  toggleResponsive?: any;
}

const logout = (dispatch: any, history: any) => {
  Globals.confirm('¿Desea cerrar sesión?', async () => {
    await performLogout();
    history.replace('/login');
    Globals.quitLoading();
  });
};

const Header = (props: Props) => {
  const header = useSelector((state: RootState) => state.header);
  const subheader = useSelector((state: RootState) => state.subheader);
  const user = useSelector((state: RootState) => state.user);
  const history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation();
  const apacuanaContext: any = useApacuana();

  return (
    <div id='header' className={props.className}>
      <div className='container-blue-top'>
        <div className='container-logo'>
          <button
            className='navbar-toggler'
            type='button'
            onClick={() => {
              props.toggleSidebar();
            }}
          >
            <img src={MenuIcon} />
          </button>
          <button
            className='navbar-toggler responsive'
            type='button'
            onClick={() => {
              props.toggleResponsive();
            }}
          >
            <img src={MenuIcon} />
          </button>
          <Link to='/'>
            <img src={Logo} />
          </Link>
          <Link to='/' className='responsive'>
            <img src={Logo} />
          </Link>
        </div>
        <div className='container-back-top'>
          {header.onBack && (
            <div className='arrow-back' onClick={header.onBack}>
              <img src={ArrowLeft} />
            </div>
          )}
          <div className='container-titles'>
            <h3 className='title-top'>{header.title}</h3>
            <h4 className='subtitle-top'>{subheader.title}</h4>
          </div>
        </div>
        <div className='container-buttons-top'>
          <div className='container-buttons-web'>
            <Link to='/profile'>
              <button className={`btn-profile ${location.pathname == '/profile' ? 'active' : ''}`}>
                <span>Mi Cuenta</span>
              </button>
            </Link>
            <button
              className='btn-logout'
              onClick={() => {
                apacuanaContext?.sdk?.close();

                logout(dispatch, history);
                // apacuanaContext?.setIsInitialized(false);
              }}
            >
              <img src={LogoutIcon} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
